import { buildRuntimeSchema } from "../runtime-schema.js";
import { ProjectSchemaImpl } from "./project-schema.js";
export class RuntimeSchema extends ProjectSchemaImpl {
    constructor(runtimeSchema, layers) {
        super(runtimeSchema, layers);
    }
    static buildSchema(userSchema, layers) {
        const runtimeSchema = buildRuntimeSchema(userSchema, layers);
        return new RuntimeSchema(runtimeSchema, layers);
    }
    static safeBuildSchema(userSchema, layers) {
        try {
            return RuntimeSchema.buildSchema(userSchema, layers);
        }
        catch { }
    }
    static fromJson(runtimeSchema, layers) {
        return new RuntimeSchema(runtimeSchema, layers);
    }
}
